import { Injectable } from '@angular/core';
import { map } from "rxjs";
import { HttpService } from "../common/http-service";
import { environment } from "../../../../environments/environment";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import {
  NotificationPaginationHelperModel
} from "../../../resy-modul/models/notifications/notification-pagination-helper.model";

const NOTIFICATION_API = environment.apiURL + '/api/mng/Notification/';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  //#region Fields
  //#endregion

  //#region Constructor
  constructor(private _httpService: HttpService, private _httpClient: HttpClient) {
  }
  //#endregion

  //#region Public Methods
  listNotifications(model: NotificationPaginationHelperModel) {
    const params = new HttpParams({ fromObject: model });
    let url = NOTIFICATION_API + "listnotifications";
    return this._httpClient.get(url, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }).set('Authorization', `Bearer ${localStorage.getItem("resy_access_token") as string}`),
      params
    }).pipe(map(response => {
      return response;
    }));
  }

  viewNotification(id: string) {
    let url = NOTIFICATION_API + 'viewnotification?notificationId=' + id;
    return this._httpService.httpGet(url)
      .pipe(map(response => {
        return response;
      }));
  }

  viewAllNotifications() {
    let url = NOTIFICATION_API + 'viewallnotifications';
    return this._httpService.httpPost(url)
      .pipe(map(response => {
        return response;
      }));
  }
  //#endregion
}
